
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { environment } from 'src/environments/environment';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Router } from '@angular/router';
import { CookiesService } from 'src/app/shared/cookies.service';

@Component({
  selector: 'app-create-supplier',
  templateUrl: './create-supplier.component.html',
  styleUrls: ['./create-supplier.component.scss']
})
export class CreateSupplierComponent implements OnInit {

	baseUrl = environment.okountUrl;
	supplierForm: FormGroup;
	submitted = false;
	groupList: any;
	msme_config: string = "false"
	showMessage: boolean = false;
	alertType  = '';
	message: string  = ``;

	countryArr: any = [];
	stateArr: any = [];
	cityArr: any = [];
	createdSupplierId: string;
	createdSupplierCode = ""
	newSupplier : boolean = true
	isTenantIndian: boolean = false;
	remainingAmount = 0
    amountType = 'credit'
	isHQBranch: boolean = false;
	isHQCompany: boolean = false;
	vatAlternetname: string = 'VAT'
	isAadesh: boolean = false

	@ViewChild('confirmModal',{static:true}) confirmModal : ElementRef
	@ViewChild('closeModal',{static:true}) closeModal : ElementRef
	@ViewChild("openSuccessModal", { static: true }) openSuccessModal: ElementRef;
	@ViewChild('confirmUpdateModal',{static:true}) confirmUpdateModal : ElementRef;
    @ViewChild('closeUpdateModal',{static:true}) closeUpdateModal : ElementRef;
	branches = []
	companies = []
	constructor(private fb: FormBuilder, private spinner: NgxSpinnerService, public commonService: CommonServiceService, private router: Router,  private cookieService : CookiesService) {
	}

	async ngOnInit() {
		
		this.isTenantIndian = this.commonService.checkTenantIndian()
		this.spinner.show();
		setTimeout(() => {
			this.spinner.hide();
		}, 1000);
		this.supplierForm = this.fb.group({
			parent_id: ['30', Validators.required],
			address_1: [''],
			city_id : [''],
			city_name : [''],
			state_id : [''],
			state_name : [''],
			country_id : ['101'],
			country : [''],
			gst_number: [''],
			gst_expiry_date: [''],
			vat_number: [''],
			telephone: [''],
			mobile_no: [''],
			primary_email: [''],
			secondary_email: [''],
			pan_number: [''],
			remarks: [''],
			balance: [''],
			name: ['', Validators.required],
			balance_type: ['debit'],
			is_card_account : [false],
			sync_in_branches: [''],
			currency_rate:[''],
			local_balance: [''],
			currency:[''],
			is_branch:[false],
			branch:{},
			company:{},
			aadhar_no: [''],
			msme_category: ['']
		})

		this.getGroups()
		this.getCountries()
		this.getStates('101')

		this.isHQCompany = this.commonService.checkHQCompany()
		if(this.isHQCompany==true){
			this.getAllCompanys()
		}
		this.isHQBranch = await this.commonService.checkHQBranch()
		if(this.isHQBranch==true){
			this.getAllBranches()
			
			// this.branchForm = this.fb.group({
			// 	formObj
			// })
		}
		let globalSettingConfig = this.commonService.globalSettingConfig;
	if(!globalSettingConfig || globalSettingConfig.length == 0) {
		globalSettingConfig = await this.commonService.getGlobalSettings();
	}
		if(!this.isTenantIndian){
			let inv_config = globalSettingConfig.filter(el=>el.group=='VAT')
		if(inv_config.length){
			let vat_config = inv_config[0].json_doc.value.filter(el=>el.key=='vat_rate')
			let vat_detail,vat_name
			if(vat_config.length){
				 vat_detail = vat_config[0].value
			}
			if(vat_detail && vat_detail.length ){
				vat_name = vat_detail.filter(el=>el.key=='effective_name')
			}
			if(vat_name && vat_name.length){
				this.vatAlternetname = vat_name[0].value
			}
		}
	}
		let msme_config = globalSettingConfig.filter(el => el.group == 'TRANSACTION')
					 console.log("this.msme_config 2",this.msme_config)

		if (msme_config && msme_config.length > 0) {
			let enable_msme_category = msme_config[0].json_doc.value.filter(el => el.key == 'MSME Config') 
			 this.msme_config = enable_msme_category && enable_msme_category.length > 0 ? enable_msme_category[0].value : "false"
			 console.log("this.msme_config",this.msme_config)
		}
		
	}

	openConfirmModal() :  void{
		this.hideError()
		this.confirmModal.nativeElement.click()
	}
	closeConfirmModal() :  void{
		this.closeModal.nativeElement.click()
	}

	getCountries() {
		this.commonService.getOkount(`location/country`).subscribe(res=>{
			this.countryArr = res
		})
	}

	reset() {
		this.supplierForm.reset();
	  }

	getStates(country_id){
		let selectedCountry = this.countryArr.filter(option => {
			return option.location_id == Number(country_id);
		})
		if (selectedCountry.length > 0) {
			this.supplierForm.controls.country.setValue(selectedCountry[0].name)
		}else{
			this.supplierForm.controls.country.setValue('India')
		}
		console.log(selectedCountry)
		this.commonService.getOkount(`location/states?country_id=${country_id}`).subscribe(res=>{
			this.stateArr = res
		})
	}

	getCities(state_id){
		let selectedState = this.stateArr.filter(option => {
			return option.location_id == Number(state_id);
		})
		if (selectedState.length > 0) {
			this.supplierForm.controls.state_name.setValue(selectedState[0].name)
		}
		this.commonService.getOkount(`location/city?state_id=${state_id}`).subscribe(res=>{
			this.cityArr = res
		})
	}
	getCityName(city_id){
		let selectedCity = this.cityArr.filter(option => {
			return option.location_id == Number(city_id);
		})
		if (selectedCity.length > 0) {
			this.supplierForm.controls.city_name.setValue(selectedCity[0].name)
		}
	}

	submit() {
		
		this.submitted = true;
		this.closeConfirmModal()
		switch (this.supplierForm.value.is_card_account) {
			case "true":
				this.supplierForm.value.is_card_account = true
				break;
			case "false":
				this.supplierForm.value.is_card_account = false
				break;
			default:
				break;
		}
		if (this.supplierForm.valid) {
			this.commonService.postRequest(`${this.baseUrl}/supplier`, this.supplierForm.value).subscribe(res => {
				this.updateOpeningBalanceAdjustAcc()
				this.showMessage = false
				this.alertType = 'success-box';
				this.createdSupplierId = res[0].id ? res[0].id : ""
				this.createdSupplierCode = res[0].account_code ? res[0].account_code : ""
				this.reset()
				this.newSupplier = false
				this.message = 'Supplier saved successfully with account code. :'
				this.openSuccessModal.nativeElement.click()
			}, error => {
				this.showMessage =true
				this.alertType = 'error-box';
				this.createdSupplierId = ""
				this.message = 'Failed to create supplier. Please try Again.'
				if(error.error && error.error.message=='duplicate key value violates unique constraint \"supplier_name_un\"') this.message = 'SUPPLIER ALREADY EXIST'

			})
		}
		else {
			this.showMessage =true
			this.alertType = 'warning-box';
				this.message = 'Please fill mandatory fields.'
			return false;
		}
	}

	getGroups() {
		this.commonService.getOkount('v3account/getallsuperparents').subscribe(res => {
			this.groupList = res
			
			if(this.groupList && this.groupList.length > 0) {
				let item = this.groupList.find(item => item.account_code == 'SL0000036')
				this.supplierForm.controls.parent_id.setValue(item.id)
			}
		}, err => {

		})
	}
	hideError(){
		this.showMessage = false
	}

	closeSuccesModal(){
		this.reset()
		this.newSupplier = true
		this.showMessage = false;
		this.alertType = 'success-box';
		this.message = ``
		this.openSuccessModal.nativeElement.click()
	}

	viewSupplier(supplier) {
		this.closeSuccesModal()
        this.router.navigate([`/master/supplier/update-supplier/${supplier}`])
	}

	changeCurrentAmount(event) {
		let currency = this.supplierForm.controls.currency.value;
		let currency_rate = this.supplierForm.controls.currency_rate.value;
		if(currency && currency_rate) {
			let local_balance = this.supplierForm.controls.local_balance.value
			this.supplierForm.controls.balance.setValue((Number(local_balance) / currency_rate).toFixed(2));
		} else {
			this.supplierForm.controls.balance.setValue('')
		}
	}

	currencyChange(value){
		this.supplierForm.controls.currency_rate.setValue('');
	
	}

	getAllBranches() {
        this.commonService.getOkount(`branch`).subscribe(res=> {
          if(res && res['data']) {
            this.branches = res['data'];
			let formObj = this.branches.reduce((acc,curr)=>{
				if(curr.branch_type=='BRANCH'){
					acc[curr.branch_name]=false
				}
				return acc
			},{})
			console.log("formObj",formObj)
			this.supplierForm.controls.branch.setValue(formObj)
          }
        },err=> {
    
        })
      }

	  handleValueChange(e,branchName){
		console.log("branchName",this.supplierForm.controls.branch)
		this.supplierForm.controls.branch.value[branchName]=e.currentTarget.checked
	  }
	  async checkBalance(){
        let opening_amount = await  this.getOpeningBalanceData()
        if(this.supplierForm.controls.balance_type.value=='debit') opening_amount['debit']= Number(opening_amount['debit']) + Number(this.supplierForm.controls.balance.value)
        if(this.supplierForm.controls.balance_type.value=='credit') opening_amount['credit']= Number(opening_amount['credit']) + Number(this.supplierForm.controls.balance.value)
            console.log("opening_amount",opening_amount)
		if(this.cookieService.getCookie('SYSTACC_USER_LOGIN_DATA')) {
			let userData = JSON.parse(this.cookieService.getCookie('SYSTACC_USER_LOGIN_DATA'))
			if(userData && userData.tenant_id && (userData.tenant_id == environment.aadeshSystaccId || userData.tenant_id == environment.aadeshAedSystaccId)) {
				this.isAadesh = true;
			}
		}
        if(opening_amount && (opening_amount['debit']!=opening_amount['credit']) && this.isAadesh==false) {
            this.remainingAmount = Math.abs(Number((opening_amount['debit'] - opening_amount['credit']).toFixed(2)))
            this.amountType = opening_amount['debit']>opening_amount['credit'] ? 'credit' : 'debit'
			let res = await this.adjustAccOpeningBalance()
            if(res['balance']!=this.remainingAmount || this.amountType!=res['balance_type']){
                this.openUpdateConfirmModal()
			}else{
				this.updateOpeningBalancecombine()
			}
        }else{
            this.updateOpeningBalancecombine()
        }
    }
	adjustAccOpeningBalance(){
        return new Promise(async (resolve, reject) => {
        this.commonService.getRequestWithQueryParams(`${environment.okountUrl}/globalsearch/opening_balance`, {client: 'OB0000165'}).subscribe(res => {
            resolve(res)
        },err=>{
            console.log("err",err)
            resolve(null)
        })
    })
    }
	getOpeningBalanceData(){
        return new Promise(async (resolve, reject) => {
            this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/globalsearch/openingBalanceTotal`, {}).subscribe(res => {
                resolve(res)
            },err=> {
                resolve(null)
            })
        })
    }
	openUpdateConfirmModal(){
		this.confirmUpdateModal.nativeElement.click()
	}
	 updateOpeningBalancecombine(){
        this.closeUpdateConfirmModal()
         this.submit()
    }
	closeUpdateConfirmModal(){
		this.closeUpdateModal.nativeElement.click()
	}
	updateOpeningBalanceAdjustAcc() {
        let req_body = {
            balance: this.remainingAmount,
            balance_type: this.amountType,
            account_code: 'OB0000165'
        }
        this.commonService.putRequest(`${environment.okountUrl}/client/updateOpeningBalanceAdjust`, req_body).subscribe(res => {
           
            console.log(res)
        }, err => {
        })

    }
	getAllCompanys() {
        this.commonService.getOkount(`company`).subscribe(res=> {
          if(res && res['data']) {
            this.companies = res['data'];
			let formObj = this.companies.reduce((acc,curr)=>{
				if(curr.associate_company_id!==null){
					acc[curr.tenant_company_name]=false
				}
				return acc
			},{})
			console.log("formObj",formObj)
			this.supplierForm.controls.company.setValue(formObj)
          }
        },err=> {
    
        })
      }

	  handleCompanyChange(e,companyName){
		console.log("companyName",this.supplierForm.controls.company)
		this.supplierForm.controls.company.value[companyName]=e.currentTarget.checked
	  }
}

